<template>
  <div class="row" style=" margin-bottom: 5px;">
    <div class="col-6">
      <img  :src="getPicture" class="roundedImage" @click="selectUser" style="margin-bottom:8px">
    </div>
    <div class="col-16" style="border-bottom: 1px solid rgb(242,237,237); margin-bottom: 5px;font-size:16px;">
      <div class="username" @click="selectUser">{{user.UserName}}</div>
    </div>
   </div>
</template>
<style>
.roundedImage
{
    width: 60px;
    height: 60px;
    text-align: center;
    /* background-color: #333c4a; */
    max-width: 60px; 
    border-radius: 50%;
    display: inline-block;
    -webkit-transition: all 0.4s ease-out;
    -moz-transition: all 0.4s ease-out;
    -o-transition: all 0.4s ease-out;
    transition: all 0.4s ease-out;
    cursor: hand;
}
.username
{
   margin-left:20px;
   margin-top:10px;
}
</style>
<script>
  import Vue from 'vue';

  export default {
    props: ['user', 'product'],
    data () {
      return {
    
      }
    },
    computed: {
      getPicture () {
           var pic = "";
           if (this.user.IsHasPicture)
           {
               pic =  Vue.$urlCDN + "Images/" + this.user.PictureUrl;
           }
           else
           {
              pic = Vue.$urlCDN + "Images/0/Usr/no-user120.jpg";
           }
           return pic;
       },
    },
    methods: {
      selectUser () {
        this.$emit('user-select-event', this.user);
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/cart/CartItemUser.vue